import React from 'react'

import './scaled-stage.scss'

// eslint-disable-next-line react/display-name
export default ({ children }: React.PropsWithChildren<{}>) => (
  <div className="scaled-stage">
    <div className="scaled-stage-content">{children}</div>
  </div>
)
